import { MenuItem, Select, styled } from '@mui/material';
import { CaretDown } from '@phosphor-icons/react';

import { MAX_DISPLAYED_OPTIONS } from './utils';

export const SelectStyled = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderTop: '1px solid #707178',
  borderRadius: '4px',
  '& .MuiPaper-root': {
    border: `0.1rem solid ${theme.palette.grey[400]}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    maxHeight: `${
      (theme.customSizes.menuItemHeight + theme.customSizes.menuItemSpacing) *
        MAX_DISPLAYED_OPTIONS +
      theme.customSizes.menuItemSpacing
    }rem`,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      minWidth: '90vw',
    },
  },
  '& .MuiList-root': {
    padding: `${theme.customSizes.menuItemSpacing}rem`,
    paddingRight: `${theme.customSizes.menuItemSpacing}rem!important`, // override mui element style
    '& > li + li': {
      marginTop: `${theme.customSizes.menuItemSpacing}rem`,
    },
  },
})) as typeof Select;

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  ...theme.typography.body2,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.primaryDark.main,
  height: `${theme.customSizes.menuItemHeight}rem`,
  padding: theme.spacing(3, 4),
  '&.Mui-selected': {
    backgroundColor: theme.palette.grey[200],
  },
}));

export const ExpandMoreIconStyled = styled(CaretDown)({
  fontSize: '2rem',
});
